import React, { useEffect } from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import First from '../menevents/First'


function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Events || State of GTS";
  }, [])

  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Home"
            title="Events"
            subtitledown="Events"
           />
            <First/>
        </div>

    </>
  )
}

export default Main